
import React from 'react'
import AdminUserData from './AdminUserData'

const AdminUser = () => {
    return (
        <>
            <AdminUserData />
        </>
    )
}

export default AdminUser
